



export const Products =[]


export const discountProducts = []

export const popularProducts =[]

export function getProductById(title) {
  return Products.find((product) => product.slug === title);
}

export function getProductByChildrenCategory(category) {
  return Products.filter(
    (product) => product.children.toLowerCase() === category.toLowerCase()
  );
}

export function getProductByParentCategory(category) {
  return Products.filter(
    (product) => product.type.toLowerCase() === category.toLowerCase()
  );
}

export function getProductByName(value) {
  return Products.filter((product) =>
    product.title.toLowerCase().includes(value.toLowerCase())
  );
}
